(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('covid-lab-compendium', {
                parent: 'entity',
                url: '/covid-lab-compendium?page&sort&search',
                data: {
                    authorities: [],
                    pageTitle: 'CovidLabCompendiums'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendiums.html',
                        controller: 'CovidLabCompendiumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access);
                    }]
                }
            })
            .state('covid-lab-compendium.new', {
                parent: 'covid-lab-compendium',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-dialog.html',
                            controller: 'CovidLabCompendiumDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: function () {
                                    return {
                                        id: null,
                                        facility: CoreService.getCurrentFacility(),
                                        labCompendium: null
                                    };
                                }
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('covid-lab-compendium');
                        });
                    }
                }]
            })
            .state('covid-lab-compendium.edit', {
                parent: 'covid-lab-compendium',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-dialog.html',
                            controller: 'CovidLabCompendiumDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidLabCompendium', function (CovidLabCompendium) {
                                    return CovidLabCompendium.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('covid-lab-compendium.delete', {
                parent: 'covid-lab-compendium',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-delete-dialog.html',
                            controller: 'CovidLabCompendiumDeleteController',
                            controllerAs: 'vm',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidLabCompendium', function (CovidLabCompendium) {
                                    return CovidLabCompendium.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();
